import React from 'react'
import axios from 'axios'

import './LoginNovo.css'
import brasao from '../../assets/brasil.jpeg'
import mbtech from '../../assets/mbtech.svg'

const initialState = {
    user: {
        matricula: '',
        password: '',
        estado: ''
    }
}

export default class Login extends React.Component {
    constructor(props) {
        super(props)
        this.state = { ...initialState }
    }

    updateField(event) {
        const user = { ...this.state.user }
        user[event.target.name] = event.target.value
        this.setState({ user })
    }

    login() {
        const url = '/api/auth'
        const user = { ...this.state.user }
        axios.post(url, user)
            .then(res => {
                const { token, payload } = res.data
                localStorage.setItem('token', token)
                localStorage.setItem('id', payload.user.id)
                localStorage.setItem('nome', payload.user.nome)
                localStorage.setItem('matricula', payload.user.matricula)
                localStorage.setItem('tipo', payload.user.tipo)
                localStorage.setItem('profissao', payload.user.profissao)

                return window.location = "/"
            })
            .catch(error => {
                alert(error.response.data)
            })
    }

    render() {
        return (
            <React.Fragment>
                <div className="mx-auto quadrado">
                    <div className="form">
                        <img src={brasao} alt="Brasil" className='brasao' />

                        <label className='label label1'>Usuário</label>
                        <input type="text" className='inputField'
                            name="matricula"
                            value={this.state.matricula}
                            onChange={e => this.updateField(e)} />

                        <label className='label label2'>Senha</label>
                        <input type="password" className='inputField'
                            name="password"
                            value={this.state.password}
                            onChange={e => this.updateField(e)} />

                        <select className='inputField selectLogin'
                            name="estado"
                            value={this.state.estado}
                            onChange={e => this.updateField(e)} >
                            <option value="" disabled selected>Estado</option>
                            <option value="AL">Alagoas</option>
                            <option value="PB">Paraíba</option>
                            <option value="PE">Pernambuco</option>
                            <option value="RN">Rio Grande do Norte</option>
                        </select>

                        <button className='botaoEntrar' onClick={e => this.login()}>Entrar</button>
                    </div>
                    <img src={mbtech} alt="mbtech" className='mbtech' />
                </div>
            </React.Fragment>
        )
    }
}